// extracted by mini-css-extract-plugin
module.exports = {"collectionDetailsWrapper":"styles_collectionDetailsWrapper__9aJ4B","collectionDetailsWrapper__text":"styles_collectionDetailsWrapper__text__a5L9g"};